import React, { useContext, useEffect, useMemo } from 'react'
import TabNav from '../../ui/TabNav/TabNav'
import { Route, Switch } from 'react-router-dom'
import { AuthContext } from '../../App'
import Banners from './components/Banners/Banners'
import Pages from './components/Pages/Pages'
import Sms from './components/Sms/Sms'
import { isSmsAllowedUser } from '../../config/smsAccessControl'
import './Settings.sass'

function Settings() {
  const { setPageTitle, user } = useContext(AuthContext)
  const smsAllowed = isSmsAllowedUser(user?.uid)

  useEffect(() => {
    setPageTitle('Сайт')
  }, [setPageTitle])

  const tabNavLinks = useMemo(() => {
    const links = [
      { title: 'Банери', path: '/settings/banners' },
      { title: 'Текстова інформація', path: '/settings/pages' },
    ]
    if (smsAllowed) {
      links.push({ title: 'SMS', path: '/settings/sms' })
    }
    return links
  }, [smsAllowed])

  return (
    <>
      <TabNav links={tabNavLinks} />
      <div className="Settings">
        <Switch>
          <Route path={['/settings/banners/:bannerId', `/settings/banners`]} render={() => <Banners />} />
          <Route path={['/settings/pages/:pageId', `/settings/pages`]} render={() => <Pages />} />
          {smsAllowed ? <Route path="/settings/sms" render={() => <Sms />} /> : null}
        </Switch>
      </div>
    </>
  )
}

export default Settings
